import React, { useState } from "react";
import Select from "react-select";

const RequestingCompaniesSelect = (props) => {
  const reasons = [
    { value: "empresa_1", label: "Empresa interna 1" },
    { value: "empresa_2", label: "Empresa interna 2" },
    { value: "empresa_3", label: "Empresa interna 3" },
    { value: "empresa_4", label: "Empresa interna 4" }
  ];

  const [requestingCompany] = useState(reasons);

  const handleChangeReason = inputValue => {
    props.handleChange(inputValue, "requestingCompany");
  };

  return (
    <Select
      inputId="requestingCompany"
      onChange={handleChangeReason}
      options={requestingCompany}
      placeholder="Seleccione una opción"
      value={requestingCompany.find(
        (option) => option.value === props.value?.value
      ) || null}
    />
  );
};

export default RequestingCompaniesSelect;
